import React, { Component } from 'react';

export class SolutionInfo extends Component {
    render() {
        return (
            <div id="solution-info">
                <div className="solution-column" style={{ zIndex: 1 }}>
                    <div id="solution-column-text-left">
                        Enhance their space with luscious greens by selecting from 90+ plants
                        (exclusively curated by The Planthunter with plant guides and care tips) and dragging them into their space.
                    </div>

                    <img id="left-dashed-arrow" src="./images/generic/dashed-arrow.png" alt="" />
                    <img id="solution-icon-left" src="./images/solution/solution-icon-left.png" alt="" />
                </div>

                <div className="solution-column">
                    <div className="solution-screen">
                        <div className="solution-screen-image">
                            <img className="solution-screen-image-large" src="images/solution/solution-screen-style.jpg" alt="" />
                            <img className="solution-screen-image-small" src="images/solution/solution-screen-style-smaller.jpg" alt="" />
                        </div>

                        <div className="solution-screen-text">Style my space</div>
                    </div>
                </div>

                <div className="solution-column">
                    <div className="solution-screen">
                        <div className="solution-screen-image">
                            <img className="solution-screen-image-large" src="images/solution/solution-screen-rate.jpg" alt="" />
                            <img className="solution-screen-image-small" src="images/solution/solution-screen-rate-smaller.jpg" alt="" />
                        </div>

                        <div className="solution-screen-text">Rate my space</div>
                    </div>
                </div>

                <div className="solution-column">
                    <img id="solution-icon-right" src="./images/solution/solution-icon-right.png" alt="" />
                    <img id="right-dashed-arrow" src="./images/generic/dashed-arrow.png" alt="" />

                    <div id="solution-column-text-right">
                        Find out how healthy their current living space is based on how many plants they have.
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/sections/Solution/SolutionInfo.jsx